import React, { useEffect, useState } from "react";
import "./boxDayInfo.scss";

import EventWrapper from "../eventWrapper/EventWrapper";
import NoOneShift from "../noOneShift/NoOneShift";

import { t } from "i18next";
import { isEmpty } from "../../../../utils/validation";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const BoxDayInfo = ({
  selectedDate,
  setSelectedDate,
  count,
  dataOfDay,
  idAssociation,
  eventOfAssociation = false,
}) => {
  const navigate = useNavigate();
  const [touchStartX, setTouchStartX] = useState(0);
  const giorniSettimana = t("calendar.abbr_days", { returnObjects: true });

  /*Funzione per spostarsi di un giorno */
  const changeDate = (currentDate, direction) => {
    const newDate = new Date(currentDate); // Clona la data corrente

    if (direction === "right") {
      // Spostati di un giorno in avanti
      newDate.setDate(newDate.getDate() - 1);
    } else if (direction === "left") {
      // Spostati di un giorno indietro
      newDate.setDate(newDate.getDate() + 1);
    }

    setSelectedDate(newDate);
  };

  /*Per intercettare lo swipe */
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };
  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;

    if (touchStartX > touchEndX + 100) {
      onSwipeLeft();
    } else if (touchStartX < touchEndX - 100) {
      onSwipeRight();
    }
  };

  const onSwipeLeft = () => {
    changeDate(selectedDate, "left");
  };

  const onSwipeRight = () => {
    changeDate(selectedDate, "right");
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      className="box-day-info-container container-on-right"
    >
      <div className="box-day-info-header">
        <div className="date">
          <span className="number-of-day">{selectedDate?.getDate()}</span>
          <span className="name-of-day">
            {giorniSettimana[selectedDate?.getDay()]?.toUpperCase()}
          </span>
        </div>
        <div className="subtitle-text">
          {t("calendar.number_event_in_program", {
            number: dataOfDay.length ?? 0,
          })}
        </div>
      </div>
      <div className="box-day-info-content">
        {!isEmpty(dataOfDay) ? (
          dataOfDay.map((item, index) => {
            return (
              <EventWrapper
                key={index}
                eventName={item.name}
                idEvent={item.id}
                address={item.address}
                associationName={item.name_association}
                startDatetime={item.start_date}
                endDatetime={item.end_date}
                shifts={item.shifts}
              />
            );
          })
        ) : (
          <NoOneShift />
        )}
      </div>
      {!eventOfAssociation ? (
        <div className="button-my-event mt-2">
          <Button
            variant="info"
            onClick={() => {
              navigate(
                isEmpty(idAssociation)
                  ? "/my-event"
                  : `/dashboard/${idAssociation}/list-events`
              );
            }}
          >
            {isEmpty(idAssociation)
              ? t("calendar.event_where_i_am_volunteer")
              : t("calendar.event_association")}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default BoxDayInfo;
